import {FeatureCard} from "./FeatureCard/FeatureCard";

export const Features = () => {
    return (
        <div className="features__container">
            <FeatureCard
                icon="bi:bookmark-check"
                title="Calidad"
                description="Contamos con personal capacitado y trabajamos los mejores materiales del mercado."
            />
            <FeatureCard
                icon="ep:service"
                title="Servicios"
                description="Ofrecemos una linea exclusiva de atenci&oacute;n post venta para que puedas evacuar todas tus inquietudes."
            />
            <FeatureCard
                icon="bx:medal"
                title="Garant&iacute;a"
                description="En Dent Piletas estamos seguros de lo que hacemos, te damos una garant&iacute;a escrita sobre la piscina."
            />
        </div>
    )
}
